<ion-header [translucent]="true" *ngIf="isLoggedIn()">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        [text]="getBackButtonText()"
        defaultHref="/"
      ></ion-back-button>
    </ion-buttons>
    <ion-title>
      {{ title }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content
  [fullscreen]="true"
  *ngIf="!isLoggedIn()"
  fullscreen
  scroll-y="false"
>
  <app-tutorial (exit)="markAsRead()" *ngIf="shouldShowTutorial"></app-tutorial>
  <div class="main" *ngIf="!shouldShowTutorial">
    <ng-container *ngIf="!firstLoginLoading">
      <div (click)="loginWithStrava()">
        <img src="assets/images/connect.svg" />
      </div>
      <br />
      <ion-button
        class="bottomHalf"
        color="light"
        slot="center"
        (click)="addManualActivity()"
        >Add manual activity</ion-button
      ><br />
      <ion-button
        class="half"
        slot="center"
        color="light"
        (click)="showTutorial()"
        >Tutorial</ion-button
      ><br />
      <ion-button class="half" slot="center" color="light" (click)="goToHelp()"
        >Help</ion-button
      >
    </ng-container>
    <div class="spinner" *ngIf="firstLoginLoading">
      <ion-spinner></ion-spinner>
    </div>
  </div>

  <!--div style="text-align:center">
    <div style="text-align:center;display:inline-flex" (click)="loginWithGarmin()"><img src="assets/images/connect_garmin.svg">
    <img style="position: absolute;margin-left: 24px;max-height: 40px;" src="assets/images/connect_logo_white.png">
    </div>
  </div-->
  <ion-label *ngIf="!shouldShowTutorial" class="copyright">{{
    copyright
  }}</ion-label>
</ion-content>
<ion-content *ngIf="isLoggedIn()">
  <app-tutorial (exit)="markAsRead()" *ngIf="shouldShowTutorial"></app-tutorial>

  <ion-card *ngIf="!shouldShowTutorial">
    <ion-list-header lines="full" color="light">
      <ion-label>User Settings</ion-label>
    </ion-list-header>
    <ion-item class="profile-item" *ngIf="athlete?.profile" lines="full">
      <div class="profile-picture big-profile-picture">
        <img src="{{ athlete.profile }}" />
      </div>
    </ion-item>
    
    <ion-item lines="full">
      <ion-label>Year of birth</ion-label>
      <ion-button
        slot="end"
        color="primary"
        (click)="updateAge()"
      >
        {{ age ? age : 'SET' }}
      </ion-button>
    </ion-item>
    <ion-item lines="full">
      <ion-label>100% of heartrate</ion-label>
      <ion-button
        slot="end"
        color="primary"
        (click)="updateHeartrate()"
      >
        {{ heartrate ? heartrate : 'SET' }}
      </ion-button>
    </ion-item>
    <ion-item *ngIf="!noStrava()" lines="full" (click)="updateProfile()">
      <ion-icon slot="start" name="refresh"></ion-icon>
      <ion-label>Update Profile Details from STRAVA</ion-label>
    </ion-item>
    <ion-list-header lines="full" color="light">
      <ion-label>Application Settings</ion-label>
    </ion-list-header>
    <ion-item lines="full">
      <ion-icon slot="start" name="speedometer"></ion-icon>
      <ion-label> Imperial Unit System </ion-label>
      <ion-toggle
        id="imerialToggle"
        [(ngModel)]="imperialStatus"
        (ionChange)="toggleImperial()"
      >
      </ion-toggle>
    </ion-item>
    <ion-item lines="full">
      <ion-icon slot="start" name="moon"></ion-icon>
      <ion-label> Dark Theme </ion-label>
      <ion-toggle
        id="themeToggle"
        [(ngModel)]="myToggleStatus"
        (ionChange)="checkToggle()"
      >
      </ion-toggle>
    </ion-item>

    
    <ion-item class="profile-item">
      <ion-label class="copyright2">{{ copyright }}</ion-label>
    </ion-item>
  </ion-card>
</ion-content>
